<template>
  <div id="banner">
    <el-image :src="require('./AppBannerLogo.png')"></el-image>
    <el-image
      :src="require('./AppBannerNyg.png')"
      style="position: absolute; right: 0"
    ></el-image>

    <el-menu
      router
      :default-active="activeIndex"
      class="top-nav"
      mode="horizontal"
      background-color="#0c1430"
      text-color="#9cd9fc"
      active-text-color="#ffd0a3"
      @select="handleSelect"
    >
      <el-menu-item index="/industry">产业概况</el-menu-item>
      <el-menu-item index="/quality">数字莓政</el-menu-item>
      <!-- <el-menu-item index="/sale">数字莓市</el-menu-item> -->
      <el-menu-item index="/product/control/112340121100000">
        数字莓园
      </el-menu-item>
      <el-menu-item index="/trace">数字莓农</el-menu-item>
      <el-menu-item index="/disease">病虫害防治</el-menu-item>
      <el-menu-item index="/product/fertility">精准施肥</el-menu-item>
      <el-menu-item index="/product/plant">表型识别</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'AppBanner',
  data() {
    return {
      activeIndex: '/',
    }
  },
  computed: {
    path() {
      return this.$route.path
    },
  },
  watch: {
    // path: {
    //   immediate: true,
    //   handler: function (val) {
    //     console.log('route.path >>>>>>>>>>>>>>>>>>>>>> ', val, this.activeIndex)
    //     this.activeIndex = val
    //   },
    // },
  },
  methods: {
    handleSelect(key, keyPath) {
      // console.log(key, keyPath)
      // this.$store.commit('activePage', key)
    },
  },
}
</script>

<style scoped>
#banner {
  position: relative;
  height: 140px;
  background-image: url('./AppBanner.jpg');
}
.top-nav {
  position: absolute;
  right: 20px;
  bottom: 0;
}
</style>

<style>
.el-submenu__title {
  font-size: 18px;
}
.el-menu-item {
  font-size: 18px;
}
.el-menu--popup > .el-menu-item {
  font-size: 12px;
}
.el-menu.el-menu--horizontal {
  border-bottom: solid 1px #162036;
}
</style>



// WEBPACK FOOTER //
// src/components/AppBanner.vue